// 暗亮主题对应的颜色
export const backgroundModeMap = {
  light: {
    globalBgColor: '#f4f4f4', // 亮色主题的背景色
    componentBgColor: '#ffffff', // 亮色主题下，组件的背景色
    mainColor: '#161616', // 亮色主题，下主文字颜色
    subColor: '#7A7A7A', // 亮色主题下，次文字颜色
  },
  dark: {
    globalBgColor: '#171920', // 暗黑主题的背景色
    componentBgColor: '#1F2128', // 暗黑主题下，组件的背景色
    mainColor: '#ffffff', // 暗黑主题下，主文字颜色
    subColor: '#8d8d8d', // 暗黑主题下，次文字颜色
  }
}

// 广告位枚举
export const defaultAdStyleEnum = {
  menu: {
    style: 'slide',
    width: 764,
    height: 480,
  },
  home: {
    style: 'slide',
    width: 828,
    height: 900,
  },
  finish: {
    style: 'slide',
    width: 796,
    height: 240,
  },
  openScreen: {
    style: 'slide',
    width: '100vw',
    height: '100vh',
  },
}
